import { FormNumericInput } from 'components/form-fields';
import { useValidation } from 'hooks/useValidation';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import classNames from 'classnames';

export function OcrNumberOfNumberLayout(
    {
        loading = false,
        disabled = false,
        readonly = false,
        firstNumberHeading,
        layout,
        onChange,
        secondNumberHeading
    }
) {
    const defaultMinValue = 1;
    const defaultMaxValue = 12;

    const [_, errors, validate] = useValidation();

    const [layoutAnswer, setLayoutAnswer] = useState({
        visitNumber: null,
        ofVisit: null
    });

    const [maxAllowedVisitNumber, setMaxAllowedVisitNumber] = useState(defaultMaxValue);
    const [minAllowedOfVisit, setMinAllowedOfVisit] = useState(defaultMinValue);

    useEffect(() => {
        validateLayout();
    }, [layoutAnswer, maxAllowedVisitNumber, minAllowedOfVisit]);

    useEffect(() => {
        if (layoutAnswer.visitNumber) {
            setMinAllowedOfVisit(layoutAnswer.visitNumber < defaultMaxValue ? layoutAnswer.visitNumber : defaultMaxValue);
        } else {
            setMinAllowedOfVisit(defaultMinValue);
        }

        if (layoutAnswer.ofVisit) {
            setMaxAllowedVisitNumber(layoutAnswer.ofVisit > defaultMinValue ? layoutAnswer.ofVisit : 1);
        } else {
            setMaxAllowedVisitNumber(defaultMaxValue);
        }
    }, [layoutAnswer]);

    useEffect(() => {
        if (layout.table && layout.table.rows && layout.table.rows.length > 0) {
            const clonedAnswer = { ...layoutAnswer };

            clonedAnswer.visitNumber = layout.table.rows[0][0] ? +layout.table.rows[0][0] : null;
            clonedAnswer.ofVisit = layout.table.rows[0][1] ? +layout.table.rows[0][1] : null;

            setLayoutAnswer(clonedAnswer);
        }
    }, [layout]);

    function validateLayout() {
        const rules = getRules();
        validate(rules, layoutAnswer);
    }

    function getRules() {
        return [
            { fieldName: 'visitNumber', required: true, minValue: defaultMinValue, maxValue: maxAllowedVisitNumber },
            { fieldName: 'ofVisit', required: true, minValue: minAllowedOfVisit, maxValue: defaultMaxValue },
        ];
    }

    function onVisitNumberChange(value) {
        const formatedValue = value ? +value : null;
        if (formatedValue !== layoutAnswer.visitNumber) {
            const clonedAnswer = { ...layoutAnswer };

            clonedAnswer.visitNumber = value ? +value : null;

            setLayoutAnswer(clonedAnswer);
            updateRows(clonedAnswer);
        }
    }

    function onOfVisitChange(value) {
        const formatedValue = value ? +value : null;
        if (formatedValue !== layoutAnswer.ofVisit) {
            const clonedAnswer = { ...layoutAnswer };

            clonedAnswer.ofVisit = value ? +value : null;

            setLayoutAnswer(clonedAnswer);
            updateRows(clonedAnswer);
        }
    }

    function updateRows(clonedAnswer) {
        const layoutClone = {
            ...layout,
            table: {
                ...layout.table,
                rows: [[clonedAnswer.visitNumber ? clonedAnswer.visitNumber.toString() : null, clonedAnswer.ofVisit ? clonedAnswer.ofVisit.toString() : null]]
            }
        };

        onChange(layoutClone);
    }

    return (
        <Fragment>
            <div className={classNames({ "hide-in-print": !readonly, "hidden": readonly })}>
                <FormNumericInput
                    disabled={disabled}
                    onValueChange={onVisitNumberChange}
                    selectedValue={layoutAnswer.visitNumber}
                    headingText={firstNumberHeading}
                    max={maxAllowedVisitNumber}
                    min={defaultMinValue}
                    dangerHelperText={errors.visitNumber}
                    disabledInput
                />
                <FormNumericInput
                    disabled={disabled}
                    onValueChange={onOfVisitChange}
                    selectedValue={layoutAnswer.ofVisit}
                    headingText={secondNumberHeading}
                    max={defaultMaxValue}
                    min={minAllowedOfVisit}
                    dangerHelperText={errors.ofVisit}
                    disabledInput
                />
            </div>
            <p className={classNames({ "show-in-print": !readonly, "visible": readonly, "bp6-skeleton": loading })}>{layoutAnswer.visitNumber} of {layoutAnswer.ofVisit}</p>
        </Fragment>
    );
}

OcrNumberOfNumberLayout.propTypes = {
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    firstNumberHeading: PropTypes.string.isRequired,
    secondNumberHeading: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool
};
